/**
 * 500 PAGE TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

function Page500() {

    return (

        <div className="error-500">

            <div className="error-500__title">
                <FormattedMessage id="General_CoreFunctionality_Error_error.500Title" />
            </div>

            <div className="error-500__message">
                <FormattedMessage id="General_CoreFunctionality_Error_error.message" />
            </div>

        </div>

    );

}

export default Page500;


// WEBPACK FOOTER //
// ./src/scripts/pages/ErrorPage/templates/ErrorPage.500.jsx